import { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import type { PlaygroundTab } from '@/store/playground';

const DynamicPlayground = lazy(() => import('./DynamicPlayground').then((m) => ({ default: m.DynamicPlayground })));

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center h-full">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}

interface PlaygroundRouterProps {
  tab: PlaygroundTab;
}

export function PlaygroundRouter({ tab }: PlaygroundRouterProps) {
  const task = tab.task;

  return (
    <Suspense fallback={<LoadingFallback />}>
      {task && task !== 'unknown' ? (
        <DynamicPlayground tabId={tab.id} />
      ) : (
        <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
          Unsupported model type: <code className="ml-1 bg-secondary px-1 rounded">{task}</code>
        </div>
      )}
    </Suspense>
  );
}
